import type { AuthUser } from './auth-provider.js';

export const CRM_PRIVILEGE_DEPTH = {
  None: 0,
  Basic: 1,
  Local: 2,
  Deep: 4,
  Global: 8,
} as const;

const CRM_SECURITY_ADMIN_PRIVILEGES = [
  'prvWriteRole',
  'prvWriteSystemUser',
  'prvWriteBusinessUnit',
  'prvWriteFieldSecurityProfile',
];

const CRM_SECURITY_READ_PRIVILEGES = [
  'prvReadRole',
  'prvReadSystemUser',
  'prvReadBusinessUnit',
  'prvReadFieldSecurityProfile',
];

export function crmPrivilegeDepth(
  user: Partial<Pick<AuthUser, 'privileges'>> | null | undefined,
  privilegeName: string,
) {
  return user?.privileges?.[privilegeName] ?? CRM_PRIVILEGE_DEPTH.None;
}

export function hasCrmPrivilege(
  user: Partial<Pick<AuthUser, 'privileges'>> | null | undefined,
  privilegeName: string,
  minDepth: number = CRM_PRIVILEGE_DEPTH.Basic,
) {
  return crmPrivilegeDepth(user, privilegeName) >= minDepth;
}

export function hasAnyCrmPrivilege(
  user: Partial<Pick<AuthUser, 'privileges'>> | null | undefined,
  privilegeNames: string[],
  minDepth: number = CRM_PRIVILEGE_DEPTH.Basic,
) {
  return privilegeNames.some((name) => hasCrmPrivilege(user, name, minDepth));
}

export function isCrmSecurityAdmin(user: Partial<Pick<AuthUser, 'privileges'>> | null | undefined) {
  return hasAnyCrmPrivilege(user, CRM_SECURITY_ADMIN_PRIVILEGES);
}

export function canReadCrmSecuritySettings(
  user: Partial<Pick<AuthUser, 'privileges'>> | null | undefined,
) {
  return isCrmSecurityAdmin(user) || hasAnyCrmPrivilege(user, CRM_SECURITY_READ_PRIVILEGES);
}
